module.exports = "../../../../platform/assets/pageMainIcon/youth_yewushezhilei7.svg";